/*
    @author Jaromír Navara [BG] <web@bagricek.cz>
    26.8.2016 4:14
*/
$(function() {
  var addHoverSounds, ga, redrawButtons, ref, soundSettings;
  $.nette.init();
  if (typeof ga === "undefined" || ga === null) {
    ga = function() {
      return console.log("using dummy ga");
    };
  }
  $(document).on("mousedown", "a#navigation_sound", function() {
    var ref, ref1;
    ion.muted = !$(this).hasClass("navigation_sound_off");
    if (ion.muted) {
      if (typeof gameType !== "undefined" && gameType !== null) {
        ga('send', 'event', gameType, 'Zakázat zvuk', gameType);
      }
      ion.sound.pause("sound_music");
      ion.sound.pause("sound_voice");
      return (ref = $.player) != null ? ref.jPlayer("volume", 0) : void 0;
    } else {
      if (typeof gameType !== "undefined" && gameType !== null) {
        ga('send', 'event', gameType, 'Povolit zvuk', gameType);
      }
      ion.sound.play("sound_music");
      ion.sound.play("sound_voice");
      return (ref1 = $.player) != null ? ref1.jPlayer("volume", 1) : void 0;
    }
  });
  $("#points").click(function() {
    return ga('send', 'event', gameType, 'Zobrazit výsledkovou listinu', gameType);
  });
  $("#frm-saveVictory").submit(function() {
    return ga('send', 'event', gameType, 'Uložit výsledek', gameType);
  });
  $(".navigation_restart").click(function() {
    return ga('send', 'event', gameType, 'Hrát znovu', gameType);
  });
  $(".navigation_gallery").click(function() {
    return ga('send', 'event', gameType, 'Zobrazit galerii', gameType);
  });
  $("#print").click(function() {
    return ga('send', 'event', gameType, 'Vytisknout obrázek', gameType);
  });
  $("#frm-saveVictory-name").focus(function() {
    return $(this).attr("placeholder", "");
  });
  $.fn.setSvgInline = function($self) {
    var $svg, background, backgroundUrl, fileSuffix;
    background = $self.css("background-image") ? $self.css("background-image").match(/url\((.+)\)/) : null;
    if (!background) {
      $svg = $self.find("span:not(.puzzle_preview)");
      background = $svg[0] ? $svg.css("background-image").match(/url\((.+)\)/) : void 0;
    }
    if (background) {
      backgroundUrl = background[1].replace(/'/g, "").replace(/"/g, '');
      fileSuffix = backgroundUrl.split(".").pop();
      if (fileSuffix === "svg") {
        return $.get(backgroundUrl, function(data) {
          $svg = $(data).find("svg");
          $svg.attr("id", null);
          if (!$svg.attr("viewBox")) {
            $svg.attr({
              "viewBox": `0 0 ${parseInt($svg.attr('width'))} ${parseInt($svg.attr('height'))}`
            });
          }
          $self.find("svg").remove();
          $self.css("background-image", "none").prepend($svg.outerHTML());
          return $self.css("opacity", 1);
        });
      }
    }
  };
  redrawButtons = function() {
    return $(".action, .plus, .puzzle_preview, .type").each(function() {
      return $.fn.setSvgInline($(this));
    });
  };
  redrawButtons();
  window.redrawButtons = redrawButtons;
  $.nette.ext('snippets').after(function(data) {
    var $nowPlayingElem, nowPlaying;
    if (data.selector === "#snippet--content") {
      redrawButtons();
      addHoverSounds();
      nowPlaying = window.nowPlaying;
      $nowPlayingElem = $("a[data-audioid='" + nowPlaying + "']");
      console.log("Searching for a[data-audioid='" + nowPlaying + "']");
      console.log($nowPlayingElem[0] ? "found!" : "not here");
      if ($nowPlayingElem[0]) {
        $nowPlayingElem.removeClass("navigation_play").addClass("navigation_pause").attr("style", false).show();
        return $.fn.setSvgInline($nowPlayingElem);
      }
    }
  });
  $('#snippet--mute').bind('DOMSubtreeModified', function(e) {
    if (e.target.innerHTML.length > 0) {
      return $.fn.setSvgInline($(e.target).find(".action"));
    }
  });
  $('#navigation_pause').click(function(e) {
    return setTimeout(function() {
      $(e.currentTarget).attr("style", "display: inline");
      return $.fn.setSvgInline($(e.currentTarget));
    }, 50);
  });
  $('iframe[src*="youtube"]').wrap($('<div class="youtube-wrapper" />'));
  String.prototype.hashCode = function() {
    var chr, hash, i, j, ref;
    hash = 0;
    i = 0;
    chr;
    if (this.length === 0) {
      return hash;
    }
    for (i = j = 0, ref = this.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
      chr = this.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0;
    }
    return hash;
  };
  soundSettings = {
    swfPath: 'https://cdnjs.cloudflare.com/ajax/libs/jplayer/2.9.2/jplayer/jquery.jplayer.swf',
    solution: 'html, flash',
    supplied: 'mp3',
    preload: true,
    ready: null,
    muted: false
  };
  addHoverSounds = function() {
    return $("a.has-sound").each(function() {
      var $player, $self, settings, sound;
      $self = $(this);
      sound = $self.attr("data-sound-hover");
      if ($("#sounds").find(`.sound-${sound.hashCode()}`).length === 0) {
        $player = $(`<div class='sound-${sound.hashCode()}'/>`);
        $("#sounds").append($player);
        settings = soundSettings;
        settings.ready = function() {
          return $(this).jPlayer("setMedia", {
            title: "",
            mp3: `/uploads/original${sound}.mp3`
          });
        };
        return $(`#sounds .sound-${sound.hashCode()}`).jPlayer(settings);
      }
    });
  };
  addHoverSounds();
  $("body").on("mouseover tap", "a.webik-block[data-sound-hover]", function(e) {
    var sound;
    e.preventDefault();
    sound = $(this).attr("data-sound-hover");
    if (!$("a#navigation_sound").hasClass("navigation_sound_off")) {
      return $(`#sounds .sound-${sound.hashCode()}`).jPlayer("play");
    }
  });
  if (typeof History !== "undefined" && History !== null) {
    if ((ref = History.Adapter) != null) {
      ref.bind(window, 'statechange', function() {
        var State;
        console.log("statechange");
        return State = History.getState();
      });
    }
  }
  $(document).on("click", ".ajax.route", function() {
    var path;
    console.log("replaceState " + path);
    path = $(this).attr("href");
    return History.replaceState(null, null, path);
  });
  $.fn.setSvgInline = function($self) {
    var $svg, background, backgroundUrl, fileSuffix;
    background = $self.css("background-image") ? $self.css("background-image").match(/url\((.+)\)/) : null;
    if (!background) {
      $svg = $self.find("span:not(.puzzle_preview)");
      background = $svg[0] ? $svg.css("background-image").match(/url\((.+)\)/) : void 0;
    }
    if (background) {
      backgroundUrl = background[1].replace(/'/g, "").replace(/"/g, '');
      fileSuffix = backgroundUrl.split(".").pop();
      if (fileSuffix === "svg") {
        //        console.log getting: backgroundUrl
        return $.get(backgroundUrl, function(data) {
          $svg = $(data).find("svg");
          $svg.attr("id", null);
          if (!$svg.attr("viewBox")) {
            $svg.attr({
              "viewBox": `0 0 ${parseInt($svg.attr('width'))} ${parseInt($svg.attr('height'))}`
            });
          }
          $self.find("svg").remove();
          $self.css("background-image", "none").prepend($svg.outerHTML());
          return $self.css("opacity", 1);
        });
      }
    }
  };
  $.fn.setSvgInline($("#logo"));
  $("#disqus_thread").each(function() {
    var d, disqus_config, s;
    disqus_config = function() {
      this.page.url = window.location.href;
      return this.page.identifier = "gb";
    };
    d = document;
    s = d.createElement('script');
    s.src = '//krytfolimanka.disqus.com/embed.js';
    s.setAttribute('data-timestamp', new Date());
    return (d.head || d.body).appendChild(s);
  });
  $('.masonry').imagesLoaded(function() {
    return $('.masonry').masonry({
      itemSelector: '.m-item',
      columnWidth: '.grid-sizer',
      percentPosition: true
    });
  });
  return $("table").addClass("table");
});

jQuery.fn.outerHTML = function(s) {
  if (s) {
    return this.before(s).remove();
  } else {
    return jQuery("<p>").append(this.eq(0).clone()).html();
  }
};
